import { create } from 'zustand';

import { UsersPageDataRow } from 'api/users/types';

interface ManageUserModalState {
  isEdit: boolean;
  isOpen: boolean;
  userData?: UsersPageDataRow;
  onManageUserModalClose: () => void;
  onManageUserModalOpen: (isEdit: boolean, userData?: UsersPageDataRow) => void;
}

export const useManageUserModalStore = create<ManageUserModalState>(set => ({
  isOpen: false,
  isEdit: false,
  userData: undefined,
  onManageUserModalClose: () => set({ isOpen: false, isEdit: false, userData: undefined }),
  onManageUserModalOpen: (isEdit: boolean, userData?: UsersPageDataRow) =>
    set({ isEdit: isEdit, isOpen: true, userData: userData ?? undefined }),
}));
